import "core-js/modules/es.object.to-string.js";
import _interopRequireWildcard from "C:/project/\u6587\u5316\u5BAB/code/whg/Web/Web/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/interopRequireWildcard";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchList as typeList } from "@/api/PMS/communityPartyBuilding/activityType";
import { fetchList } from "@/api/PMS/orderCheck/orderCheck";
import waves from "@/directive/waves"; // 水波纹指令

import detail from "./detail";
import { formatJson } from "@/utils/index";
export default {
  name: "ComplexTable",
  components: {
    detail: detail
  },
  directives: {
    waves: waves
  },
  data: function data() {
    return {
      list: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10
      },
      title: "",
      chooseItem: {},
      dialogFormVisible: false,
      dates: [],
      activeTypeOption: [],
      exLists: []
    };
  },
  created: function created() {
    if (this.$route.query.orderNo != undefined && this.$route.query.orderNo != null && this.$route.query.orderNo != "") {
      this.listQuery.orderNo = this.$route.query.orderNo;
    }

    this.getTypeOption();
    this.getList();
  },
  methods: {
    getTypeOption: function getTypeOption() {
      var _this = this;

      typeList({
        appType: 1,
        page: 1,
        limit: 9999
      }).then(function (res) {
        if (res.data.code === 200) {
          _this.activeTypeOption = res.data.data;
        }
      });
    },
    handCancle: function handCancle(reload) {
      if (reload) {
        this.getList();
      }

      this.dialogFormVisible = false;
    },
    getList: function getList() {
      var _this2 = this;

      this.listLoading = true;

      if (this.dates !== null && this.dates.length > 0) {
        this.listQuery.beginDate = this.dates[0];
        this.listQuery.endDate = this.dates[1];
      } else {
        this.listQuery.beginDate = "";
        this.listQuery.endDate = "";
      }

      fetchList(this.listQuery).then(function (response) {
        _this2.list = response.data.data;
        _this2.total = response.data.total;
        _this2.listLoading = false;
      });
    },
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleDetail: function handleDetail(data) {
      this.chooseItem = data;
      this.title = "核销详情";
      this.dialogFormVisible = true;
    },
    // 导出
    handleExport: function handleExport() {
      var _this3 = this;

      this.exLists = [];
      this.$confirm("你确定要导出订单核销信息吗, 是否继续?", "提示").then(function () {
        fetchList({
          activityId: _this3.listQuery.activityId,
          orderNo: _this3.listQuery.orderNo,
          activityTitle: _this3.listQuery.activityTitle,
          itemName: _this3.listQuery.itemName,
          studentName: _this3.listQuery.studentName,
          tel: _this3.listQuery.tel,
          beginDate: _this3.listQuery.beginDate,
          endDate: _this3.listQuery.endDate
        }).then(function (response) {
          _this3.exLists = response.data.data;

          if (_this3.exLists !== null && _this3.exLists.length > 0) {
            Promise.resolve().then(function () {
              return _interopRequireWildcard(require("@/vendor/Export2Excel"));
            }).then(function (excel) {
              var tHeader = ["核销编号", "订单编号", "项目类型", "项目名称", "报名内容", "单价", "微信昵称", "姓名", "联系方式", "报名时间", "所属教练", "核销时间"];
              var fileterVal = ["serialNo", "orderNo", "activityTypeName", "activityTitle", "itemName", "unitPrice", "nickName", "studentName", "tel", "enrollmentTime", "coachName", "opDate"];
              var data = formatJson(fileterVal, _this3.exLists);
              excel.export_json_to_excel({
                header: tHeader,
                data: data,
                filename: "订单核销信息",
                autoWidth: true,
                bookType: "xlsx"
              });
            });
          } else {
            _this3.Alert({
              alertType: "error",
              message: "暂无数据，无法导出！"
            });
          }
        });
      });
    }
  }
};